import { EventBus } from "@/lib/event_bus";

import store from "@/vuex/store";

export const resetCollection = (collection: string) => {
  store.commit("replace", { state: collection, data: {} });
};

export const setCollectionItem = (
  collection: string,
  key: string | number,
  value: any
) => {
  store.commit("setDictionaryItem", { dictionary: collection, key, value });

  // collections require deep watch (expensive) so broadcast that we have an update to this item
  EventBus.$emit(`update-${collection}`, value);
};
